import React from 'react';
import Icon from './Icon';

const WindowsIcon = ({ size, color = 'currentColor', className, ...props }) => {
  return (
    <Icon size={size} color={color} className={className} {...props}>
      <path 
        d="M3.00098 5.47902L10.3778 4.4625V11.5902H3.00098V5.47902ZM3.00098 18.521L10.3778 19.5375V12.4982H3.00098V18.521ZM11.1894 19.646L21.001 21V12.4982H11.1894V19.646ZM11.1894 4.35402V11.5902H21.001V3L11.1894 4.35402Z" 
        fill={color}
      />
    </Icon>
  );
};

export default WindowsIcon;
